import { Component, NgZone } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {ContentstackService} from '../../app/contentstack';

@Component({
  selector: 'detail',
  templateUrl: 'detail.html'
})
export class DetailPage {
  selectedNew: any;
  detail: any;
  
  constructor(public zone: NgZone,public navCtrl: NavController, public navParams: NavParams, private ContentstackService:ContentstackService) {
    this.selectedNew = navParams.get('item');
    var Query = ContentstackService.Stack.ContentType("news").Query();
       	Query
       .where('uid',this.selectedNew)
       .toJSON()
       .find()
       .spread((entries, schema, count) => {
       		this.zone.run(() =>{
       			this.detail = entries[0];
       	   });
       },(err) => {
       		console.log("err",err);
       });
    
    
    
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/details/detail.ts